import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=c83b437e"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=c83b437e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports